import React from 'react';
import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';

export const SubscriptionConfirmationLandingPage = lazy(
  () =>
    import(
      '@aboutyou/logic-components/src/backend-services/NewsletterSubscription/SubscriptionConfirmationLandingPage'
    ).then(mod => ({default: mod.SubscriptionConfirmationLandingPage})),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
